var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-append-button"},[_c('button',{staticClass:"base-append-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
    },attrs:{"disabled":_vm.disabled,"role":"button"},on:{"click":_vm.execute}},[_vm._t("default",function(){return [_c('span',[_vm._v("Text")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }